<template>
  <div :class="wrapperClasses">
    <label v-for="item in items" :key="item.value" :class="itemClasses(item)">
      <input
        type="radio"
        :name="name"
        class="radios__item-radio"
        :value="item.value"
        v-model="value"
        @change="selectionChanged"
      />
      <component
        v-if="item.icon"
        :is="item.icon"
        :extra-classes="itemIconClasses(item)"
      />
      <template v-if="item.title">
        {{ item.title }}
      </template>
    </label>
  </div>
</template>

<script>
  import Caret from '@/components/icons/Caret'
  import CircleEmpty from '@/components/icons/CircleEmpty'
  import Check from '@/components/icons/Check'

  export default {
    name: 'radios',
    props: {
      name: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
      default: {
        type: String,
      },
      extraClasses: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      Caret,
      CircleEmpty,
      Check,
    },
    data() {
      return {
        value: false,
      }
    },
    mounted() {
      if (this.default) {
        this.value = this.default
      }
    },
    computed: {
      wrapperClasses: function () {
        let classes = ['radios']
        return classes.concat(this.extraClasses).join(' ')
      },
    },
    methods: {
      itemClasses: function (item) {
        let classes = ['radios__item']
        if (item.value === this.value) {
          classes.push(`radios__item--active-${item.value}`)
        }
        return classes.join(' ')
      },
      itemIconClasses: function (item) {
        let classes = ['radios__item-icon']

        switch (item.value) {
          case 'high':
            classes.push('icon--caret--up')
            break

          case 'low':
            classes.push('icon--caret--down')
            break
        }

        return classes
      },
      selectionChanged: function () {
        this.$emit('selection-changed', this.value)
      },
    },
    watch: {
      default: function (newValue) {
        this.value = newValue
      },
    },
  }
</script>

<style lang="scss">
  .radios {
    $color: $grey-lighter;
    border-radius: $border-radius;
    display: inline-flex;

    &__item {
      padding: spacer(0.1) spacer(0.5);
      border: 1px solid $color;
      border-right: none;
      position: relative;
      cursor: pointer;
      transition: $transition-base;
      font-size: $font-size-sm;

      @media (min-width: $bp-xs) {
        font-size: $font-size-base;
        padding: spacer(0.1) spacer(0.75);
      }

      &:first-child {
        border-radius: $border-radius 0 0 $border-radius;
      }

      &:last-child {
        border-right: 1px solid $color;
        border-radius: 0 $border-radius $border-radius 0;
      }

      &--active {
        background: $color;
        color: $white;

        &-high {
          background: $green-dark;
          border-color: $green-dark;
          color: $white;

          &:last-child {
            border-right-color: transparent;
          }

          + .radios__item {
            border-left-color: transparent;
          }
        }

        &-default {
          border-color: $community;
          background: $community;
          color: $grey-darker;

          &:last-child {
            border-right-color: transparent;
          }

          + .radios__item {
            border-left-color: transparent;
          }
        }

        &-low {
          border-color: $grey-dark;
          background: $grey-dark;
          color: $white;

          &:last-child {
            border-right-color: transparent;
          }

          + .radios__item {
            border-left-color: transparent;
          }
        }
      }

      &-radio {
        position: absolute;
        opacity: 0;
        z-index: -1;
      }

      &-icon {
        max-width: 0.8em;
        vertical-align: middle;
      }
    }
  }
</style>
